import Logger from '../util/Logger';
import { popinApi, dashApi } from './api';
import Collection from '../models/Collection';

const joinCollection = (collectionId) => {
  return Promise.resolve().then(() => {
    if (!collectionId) {
      Logger.info('reject join()');
      throw Error('Must pass an collectionId as a param');
    } else {
      return popinApi.post(`/collections/${collectionId}/join`);
    }
  });
};

const statsCall = (endpoint) => {
  return dashApi.get(endpoint);
};

export const collectionApi = {

  create: (collection) => {
    return popinApi.post(`/collections`, collection);
  },

  update: (collection) => {
    return popinApi.put(`/collections/${collection.id}`, collection);
  },

  getCollection: (collectionId) => {
    return popinApi.get(`/collections/${collectionId}`);
  },

  join: (collectionId) => {
    return joinCollection(collectionId);
  },

  getDetails: (collectionId) => {
    return joinCollection(collectionId).then(collection => {
      return popinApi.get(`/collections/${Collection.getId(collection)}`);
    });
  },

  deleteCollection: (collectionId) => {
    return popinApi.del(`/collections/${collectionId}`);
  },

  getStats: (collectionId) => {
    return statsCall(`/collections/${collectionId}/stats`);
  }
};
